var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgErrorIcon = function SvgErrorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6.667,
    fill: "#FF6C43"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#error-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M7.788 6.845c.088.088.132.133.186.141a.2.2 0 0 0 .052 0c.054-.008.098-.053.186-.141l1.25-1.25c.176-.176.264-.264.371-.281a.3.3 0 0 1 .105 0c.107.017.195.105.372.282l.094.094c.177.177.265.265.282.372a.3.3 0 0 1 0 .105c-.017.106-.105.195-.282.372l-1.25 1.249c-.087.088-.132.132-.14.186a.2.2 0 0 0 0 .052c.008.054.053.098.14.186l1.25 1.25c.177.176.265.264.282.371a.3.3 0 0 1 0 .105c-.017.107-.105.195-.282.372l-.094.094c-.177.177-.265.265-.372.282a.3.3 0 0 1-.105 0c-.107-.017-.195-.105-.372-.282l-1.249-1.25c-.088-.087-.132-.132-.186-.14a.2.2 0 0 0-.052 0c-.054.008-.098.053-.186.14l-1.25 1.25c-.176.177-.264.265-.371.282a.3.3 0 0 1-.105 0c-.107-.017-.195-.105-.372-.282l-.094-.094c-.177-.177-.265-.265-.282-.372a.3.3 0 0 1 0-.105c.017-.107.105-.195.282-.372l1.25-1.249c.087-.088.132-.132.14-.186a.2.2 0 0 0 0-.052c-.008-.054-.053-.098-.14-.186l-1.25-1.25c-.177-.176-.265-.265-.282-.371a.3.3 0 0 1 0-.105c.017-.107.105-.195.282-.372l.094-.094c.177-.177.265-.265.372-.282a.3.3 0 0 1 .105 0c.107.017.195.105.372.282z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "error-icon_svg__a",
    width: 9.381,
    height: 9.381,
    x: 3.31,
    y: 3.31,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.12549 0 0 0 0 0.12549 0 0 0 0 0.12549 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1908_4562"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1908_4562",
    result: "shape"
  })))));
};
export default SvgErrorIcon;